import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getPermissionList = () =>
  axiosInstance.get(API_ENDPOINTS.getPermissionList);
